module.exports = __webpack_public_path__ + "static/media/image_formula_1.5840141d.webp";